// Helpers
import { makeRequest } from '@/helpers';

export const loginApi = async(data) => {
  const result = await makeRequest('auth/login', 'POST', data);
  return result;
};

export const registerApi = async(data) => {
  const result = await makeRequest('auth/register', 'POST', data);
  return result;
};

export const sendSingApi = async(formData) => {
  const result = await makeRequest(
    'signs/create-sign',
    'POST',
    formData,
    true
  );
  return result;
};

export const saveDocumentsInCloud = async(formData) => {
  const result = await makeRequest('documents/cloud', 'POST', formData, true);
  return result;
};

export const saveDocumentsInSTRJ = async(data) => {
  const result = await makeRequest('documents/storj', 'POST', {
    ...data
  });
  return result;
};

export const saveDocumentsInDrive = async(data) => {
  const userId = localStorage.getItem('userId');
  const result = await makeRequest('documents/google-re', 'POST', {
    ...data,
    userId
  });

  if (result && result.url) {
    // redirect to google drive url
    window.location.href = result.url;
  } else {
    console.log('Error: No URL received');
  }
};

export const getSingsListApi = async() => {
  const userId = localStorage.getItem('userId');
  const result = await makeRequest('signs/getSigns', 'POST', { userId });
  return result;
};

export const getAutoGeneratedSignsApi = async() => {
  // console.log('getAutoGeneratedSignsApi');
  const result = await makeRequest('signs/generateSignatures', 'POST');
  return result;
};

export const getInviteSignsListApi = async() => {
  const userId = localStorage.getItem('userId');
  const result = await makeRequest('signs/getSigns', 'POST', { userId });
  return result;
};

export const getInfoDocApi = async(documentId) => {
  const result = await makeRequest(
    'sharedDocuments/signerUsers',
    'POST',
    { documentId }
  );
  return result;
};

export const addSignersApi = async(data) => {
  const result = await makeRequest(
    'sharedDocuments/addInviteSigners',
    'POST',
    { invites: data.invites, documentId: data.documentId }
  );
  return result;
};

export const updateSignerNameApi = async(data) => {
  const result = await makeRequest(
    'sharedDocuments/update_inviteSignerData',
    'PATCH',
    data
  );
  return result;
};

export const updateOrderSignersApi = async(data) => {
  const result = await makeRequest(
    'sharedDocuments/updateOrderSigners',
    'POST',
    data
  );
  return result;
};

export const resendEmailApi = async(data) => {
  const result = await makeRequest('sharedDocuments/resendEmail', 'POST', data);
  return result;
};

export const sendURLInvitationByWhatsappApi = async(data) => {
  const result = await makeRequest('sharedDocuments/URLByWhatsapp', 'POST', data);
  return result;
};

export const deleteSignerApi = async(data) => {
  const result = await makeRequest(
    'sharedDocuments/delete_signerUsers',
    'DELETE',
    { documentId: data.documentId, userId: data.inviteId }
  );
  return result;
};

export const updateDocumentOwner = async(data) => {
  const result = await makeRequest(
    'sharedDocuments/sharedDocuments',
    'POST',
    data.formData,
    true
  );
  return result;
};

export const getDocumentCloud = async(title, id) => {
  // console.log("title in getDocumentCloud call:", title);
  const arrayBuffer = await makeRequest(
    `documents/document-cloud/${title}`,
    'GET',
    /* data */ null,
    /* isFormData */ false,
    /* requireToken */ true,
    /* responseType */ 'arraybuffer'
  );
  // Devolvemos en el shape { content } que espera handleVisualizePDF
  return { content: arrayBuffer };
};

export const getStatusDocument = async(documentId) => {
  const result = await makeRequest(
    'documents/document-status',
    'POST',
    { documentId }
  );
  return result;
};

export const updateDocumentToShare = async(data) => {
  const result = await makeRequest(
    'seguridata/update-document',
    'POST',
    data.formData,
    true
  );
  return result;
};

export const sendEmailApi = async(payload) => {
  const result = await makeRequest(
    'sharedDocuments/send-all-emails',
    'POST',
    payload
  );
  return result;
};

export const getInfoUserApi = async() => {
  const result = await makeRequest('auth/profile', 'GET');
  return result;
};

export const getLastGuestViewApi = async() => {
  const result = await makeRequest('sharedDocuments/last-guest-view', 'GET');
  return result;
};

export const updatePhoneApi = async(data) => {
  const result = await makeRequest('auth/updatePhone', 'POST', data);
  return result;
};

export const updateAvatarApi = async(data) => {
  const result = await makeRequest(
    'users/updateAvatar',
    'POST',
    data.formData,
    true
  );
  return result;
};

export const getAvatarApi = async() => {
  const result = await makeRequest('users/avatar', 'GET');
  return result;
};

export const getOthersAvatarsBatchApi = async(ids) => {
  const result = await makeRequest('users/getOthersAvatarsBatch', 'POST', { ids });
  return result;
};

export const signOwnerMIFIELApi = async(data) => {
  const userId = localStorage.getItem('userId');
  const result = await makeRequest('fiel/signDocumentOwner', 'POST', {
    ...data,
    userId
  });
  return result;
};

export const updateOwnerMIFIELApi = async(data) => {
  const userId = localStorage.getItem('userId');
  const result = await makeRequest(
    `fiel/updateDocumentSignedOwner/${data.documentId}/${userId}/${data.status}`,
    'POST'
  );
  return result;
};

export const deleteSingApi = async(signId) => {
  const userId = localStorage.getItem('userId');
  const result = await makeRequest('signs/deleteSign', 'DELETE', { signId, userId });
  return result;
};

export const getSummaryGPT = async(documentId) => {
  // console.log("documentId in getSummaryGPT call:", documentId);
  const result = await makeRequest(
    'documents/gpt3/getSumary',
    'POST',
    { documentId }
  );
  return result;
};

export const getFirstGPT = async (data) => {
  // le paso el timeout deseado (120 000 ms)
  return makeRequest(
    `documents/signlyAI/${process.env.REACT_APP_GPT3_MODEL}`,
    'POST',
    data,
    false,
    true,
    null,
    null,
    120000
  );
};

export const getPrevSigners = async() => {
  const result = await makeRequest('prevSigners/prevSigners', 'GET');
  return result.data;
};

export const updateRFCPrevSignerApi = async(data) => {
  const result = await makeRequest('prevSigners', 'PATCH', data);
  return result;
};

export const exportPdfFromShred = async(data) => {
  const result = await makeRequest(
    'sharedDocuments/sharedLastDocuments',
    'POST',
    data.formData,
    true
  );
  return result;
};

export const generateSaleApi = async(data) => {
  const result = await makeRequest('v1/generateSale', 'POST', data);
  return result;
};

export const initProcessSignOwnerApi = async(data) => {
  const userId = localStorage.getItem('userId');
  const allowAvatarDisplay = localStorage.getItem('avatarDisplay');
  const result = await makeRequest('seguridata/seguridataFIEL', 'POST', {
    ...data,
    userId,
    allowAvatarDisplay
  });
  return result;
};

export const getHashForSignatureApi = async(data) => {
  const userId = data?.userId || localStorage.getItem('userId');
  const allowAvatarDisplay = localStorage.getItem('avatarDisplay');
  const result = await makeRequest('seguridata/getHashForSignature', 'POST', {
    ...data,
    userId,
    allowAvatarDisplay
  });
  return result;
};

// Métrica de tiempo de pkcs7FromHash en el navegador. Best-effort: nunca debe romper la firma.
export const reportSignTimingApi = async(data) => {
  const result = await makeRequest('seguridata/client-timing', 'POST', data);
  return result;
};

// Reporte de errores críticos de firma (el backend lo reenvía a Discord; el webhook ya no vive en el front).
export const reportSignErrorApi = async(data) => {
  const result = await makeRequest('seguridata/client-error', 'POST', data);
  return result;
};

export const updateAndFinalizeSignature2Api = async(data) => {
  // const userId = data?.userId || localStorage.getItem("userId");
  const result = await makeRequest(
    'seguridata/updateAndFinalizeSignature2',
    'POST',
    data,
    true
  );
  return result;
};

export const finalizeSignOwnerApi = async(data) => {
  const result = await makeRequest(
    'seguridata/updateAndFinalizeSignature',
    'POST',
    data
  );
  return result;
};

export const downloadNOMApi = async(documentId) => {
  const result = await makeRequest(
    'seguridata/download-nom',
    'POST',
    { documentId },
    false,
    true,
    'text'
  );
  return result;
};

export const getDocumentCloudShared = async(documentId, id) => {
  // Solicitamos el PDF como ArrayBuffer puro
  const arrayBuffer = await makeRequest(
    'sharedDocuments/get-document',
    'POST',
    { documentId },
    /* isFormData */ false,
    /* requireToken */ true,
    /* responseType */ 'arraybuffer'
  );
  // Devolvemos en el shape { content } que espera el frontend
  return { content: arrayBuffer };
};

export const getMyDocumentsApi = async(data) => {
  const result = await makeRequest('documents/getDocuments', 'POST', data);
  return result;
};

// Búsqueda por contenido del documento (buscador del header de /home). Devuelve { results: [{ id, title,
// status, upload_date, snippet }] } con los documentos del usuario cuyo texto contiene la consulta.
export const searchDocumentsContentApi = async(query) => {
  const result = await makeRequest('documents/search-content', 'POST', { query });
  return result;
};

export const getMyCancelDocumentsApi = async(data) => {
  const result = await makeRequest('documents/get-cancels', 'POST', {
    ...data
  });
  return result;
};

export const getDocumentsPendingApi = async(data) => {
  const result = await makeRequest('documents/pending', 'POST', data);
  return result;
};

export const getDocumentsSignedApi = async(data) => {
  const result = await makeRequest('documents/signed', 'POST', data);
  return result;
};

export const getDocumentsBlockchainApi = async(data) => {
  const result = await makeRequest(
    'documents/listUserDocumentsSavedInBlockchain',
    'POST',
    data
  );
  return result;
};

export const getDocumentsByBlockchain = async(storage) => {
  const userId = localStorage.getItem('userId');
  const result = await makeRequest(
    `documents/cloud/${userId}/blockchain`,
    'GET'
  );
  return result.documentos.reverse();
};

export const getDocumentsSharedWithMeApi = async(data) => {
  const result = await makeRequest('documents/shared-with-me', 'POST', {
    ...data
  });
  return result;
};

export const getPendingSignaturesApi = async(data) => {
  const result = await makeRequest('documents/pending-signatures', 'POST', {
    ...data
  });
  return result;
};

export const rejectSignatureApi = async(documentId) => {
  const result = await makeRequest('documents/reject-signature', 'POST', {
    documentId
  });
  return result;
};

export const downloadPDFApi = async(documentId) => {
  const userId = localStorage.getItem('userId');
  // console.log("documentId in downloadPDFApi call:", documentId);
  const result = await makeRequest(
    'documents/cloud-download',
    'POST',
    { userId: userId, documentId: documentId },
    false,
    true,
    'arraybuffer'
  );
  return result;
};

export const downloadPDFApiShared = async(data) => {
  // const userId = localStorage.getItem("userId");
  const result = await makeRequest(
    'documents/cloud-download',
    'POST',
    { documentId: data.documentId, userId: data.userId },
    false,
    true,
    'arraybuffer'
  );
  return result;
};

export const cancelDocumentApi = async(documentId) => {
  const userId = localStorage.getItem('userId');
  const result = await makeRequest('documents/cancel-document', 'POST', {
    userId,
    documentId
  });
  return result;
};

export const visualizePDFApi = async(title) => {
  // Le pasamos responseType='arraybuffer' para recibir ArrayBuffer puro
  const arrayBuffer = await makeRequest(
    `documents/document-cloud/${title}`,
    'GET',
    /* data */ null,
    /* isFormData */ false,
    /* requireToken */ true,
    /* responseType */ 'arraybuffer'
  );
  // Devolvemos en el shape { content } que espera handleVisualizePDF
  return { content: arrayBuffer };
};

export const visualizePDFSharedApi = async(data) => {
  const result = await makeRequest(
    `documents/document-cloud/${data.title}/${data.userIdOwner}`,
    'GET'
  );
  return result;
};

export const deletePDFApi = async(documentId) => {
  const userId = localStorage.getItem('userId');
  const result = await makeRequest(
    'documents/deleteDocument',
    'DELETE',
    { documentId }
  );
  return result;
};

export const uploadPDFApi = async(data) => {
  const result = await makeRequest('documents/uploadDocument', 'POST', data, true);
  return result;
};

export const getDocumentsTrashApi = async(data) => {
  // const userId = localStorage.getItem("userId");
  const result = await makeRequest(
    'documents/cloud-trash',
    'POST',
    data
  );
  return result;
};

export const restoreDocApi = async(documentId) => {
  const userId = localStorage.getItem('userId');
  const result = await makeRequest(
    'documents/untrashDocument',
    'PUT',
    { documentId }
  );
  return result;
};

export const sendToTrashApi = async(documentId) => {
  const result = await makeRequest(
    'documents/trashDocument',
    'PUT',
    { documentId }
  );
  return result;
};

export const getUrlBlockchainApi = async(documentId) => {
  const result = await makeRequest('documents/storjURL', 'POST', {
    documentId
  });
  return result;
};

export const signOwnerBiometric = async(data) => {
  const userId = localStorage.getItem('userId');
  const result = await makeRequest('seguridata/seguridataFAB', 'POST', {
    ...data,
    userId
  });
  return result;
};

export const updateDocOwnerFAB = async(data) => {
  const result = await makeRequest(
    'seguridata/updateAndFinalizeSignatureFAB',
    'POST',
    data
  );
  return result;
};

export const initSignFABWithInvites = async(data) => {
  const result = await makeRequest(
    'seguridata/update-document',
    'POST',
    data.formData,
    true
  );
  return result;
};

export const getHashFABWithInvites = async(data) => {
  const userId = data.userId || localStorage.getItem('userId');
  const result = await makeRequest(
    'seguridata/getHashForSignatureFAB',
    'POST',
    { ...data, userId }
  );
  return result;
};

export const updateAndFinalizeFABWithInvites = async(data) => {
  const userId = data.userId || localStorage.getItem('userId');
  const result = await makeRequest(
    'seguridata/updateAndFinalizeSignature2FAB',
    'POST',
    { ...data, userId }
  );
  return result;
};

export const downloadEvidenceApi = async(documentId) => {
  const result = await makeRequest(
    'seguridata/download-evidencia',
    'POST',
    { documentId },
    false,
    true,
    'arraybuffer'
  );
  return result;
};
export const downloadAllDocsApi = async(documentId) => {
  const result = await makeRequest(
    'seguridata/download-all',
    'POST',
    { documentId },
    false,
    true,
    'arraybuffer'
  );
  return result;
};

export const downloadAllDocsSinglyApi = async(documentId) => {
  const result = await makeRequest(
    'sharedDocuments/download-all',
    'POST',
    { documentId },
    false,
    true,
    'arraybuffer'
  );
  return result;
};

export const updateLocationUserApi = async(data) => {
  const result = await makeRequest(
    'users/updateGeoLocation',
    'POST',
    data
  );
  return result;
};

export const getCountryAndCityApi = async(data) => {
  const response = await fetch(
    `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${data.latitude}&lon=${data.longitude}&accept-language=en`
  );
  const info = await response.json();
  return info;
};

export const getIpApi = async() => {
  const response = await fetch('http://www.geoplugin.net/json.gp');
  const info = await response.json();
  return info;
};

export const getIpNewApi = async() => {
  const response = await fetch('https://api.ipify.org/?format=json');
  const info = await response.json();
  return info.ip;
};

export const verifyPaymentApi = async(data) => {
  const userId = localStorage.getItem('userId');
  const result = await makeRequest('payments/capturePaymentOrder', 'POST', {
    ...data,
    userId
  });
  return result;
};

export const createOrderPaymentApi = async(data) => {
  const result = await makeRequest('payments/createOrderPayment', 'POST', data);
  return result;
};

export const verifyUserExistInWHMCSApi = async(data) => {
  const result = await makeRequest('whmcs/getClientDetails', 'POST', data);
  return result;
};

export const addClientInWHMCSApi = async(data) => {
  const result = await makeRequest('whmcs/addClient', 'POST', data);
  return result;
};


export const existPassApi = async(data) => {
  const userId = localStorage.getItem('userId');
  const result = await makeRequest('users/existPass', 'POST', { userId });
  return result;
};

export const updatePassApi = async(data) => {
  const userId = localStorage.getItem('userId');
  const result = await makeRequest('users/updatePass', 'POST', {
    userId,
    newPass: data.password
  });
  return result;
};

export const verifyCodeInvitesApi = async(data) => {
  const result = await makeRequest('sharedDocuments/verify-code', 'POST', {
    userId: data.userId,
    code: data.code,
    documentId: data.documentId,
    invitationToken: data.invitationToken
  });
  return result;
};

export const generateGuestTokenWithoutCodeApi = async(data) => {
  const result = await makeRequest('sharedDocuments/generate-guest-token', 'POST', {
    userId: data.userId,
    documentId: data.documentId,
    invitationToken: data.invitationToken
  });
  return result;
};

export const extractNameFromINEApi = async(data) => {
  const result = await makeRequest('auth/extract-name', 'POST', data.formData, true);
  return result;
};

export const uploadINEBackApi = async(data, onUploadProgress) => {
  const result = await makeRequest('auth/uploadINEBack', 'POST', data.formData, true, onUploadProgress);
  return result;
};

export const uploadINEWithUserApi = async(data, onUploadProgress) => {
  const result = await makeRequest('auth/uploadINEWithUser', 'POST', data.formData, true, onUploadProgress);
  return result;
};

export const getNOMapi = async(data) => {
  const result = await makeRequest('seguridata/get-data-nom', 'POST', data);
  // console.log("desde connections:", result);
  return result;
};

export const verifyNOMApi = async(data) => {
  const result = await makeRequest('seguridata/verify-nom', 'POST', data);
  return result;
};

export const resendWelcomeEmailApi = async(data) => {
  const result = await makeRequest('auth/resend-welcome-email', 'POST', data);
  return result;
};

export const checkEmailInDBApi = async(data) => {
  const result = await makeRequest('auth/check-email-in-db', 'POST', data);
  return result;
};

export const getCommentsApi = (documentId) =>
  makeRequest('comments/getComments', 'POST', { documentId });

export const postCommentApi = (documentId, payload) =>
  makeRequest('comments/addComment', 'POST', {
    documentId,
    ...payload
  });

export const updateDocumentFlagsApi = async (data) => {
  const result = await makeRequest(
    'documents/update-flags',
    'POST',
    data
  );
  return result;
};

export const getTrustedDevicesApi = async () => {
  const result = await makeRequest('users/trusted-devices', 'GET');
  return result;
};

export const deleteTrustedDeviceApi = async (id) => {
  const result = await makeRequest(`users/trusted-devices/${id}`, 'DELETE');
  return result;
};

// API pública v1: autoservicio de API keys (sección "API pública" en /settings).
// La respuesta de createApiKeyApi trae la key completa UNA sola vez: no se
// guarda en ningún store ni se loguea, solo vive en el estado del modal.
export const getApiKeysApi = async () => {
  const result = await makeRequest('apikey/keys', 'GET');
  return result;
};

export const createApiKeyApi = async (data) => {
  const result = await makeRequest('apikey/keys', 'POST', data);
  return result;
};

export const revokeApiKeyApi = async ({ id, reason }) => {
  const result = await makeRequest(
    `apikey/keys/${encodeURIComponent(id)}`,
    'DELETE',
    reason ? { reason } : {}
  );
  return result;
};
